export const ITEMS_PER_PAGE = 10;

export const INITIAL_CONSTRUCTION_TYPE_STATE = {
  uuid_plan: '',
  name: '',
  surface: '',
  description: '',
  image_url: '',
};
